module.exports = __webpack_public_path__ + "img/server-tea.a929220f.png";